var DOCS_URL = 'http://www.telerik.com/kendo-angular-ui/components/internationalization/troubleshooting/';
/**
 * @hidden
 */
export var errorSolutions = {
    'NoCurrency': "Solution: " + DOCS_URL + "#toc-no-currency",
    'NoCurrencyDisplay': "Solution: " + DOCS_URL + "#toc-no-currency-display",
    'NoCurrencyRegion': "Solution: " + DOCS_URL + "#toc-no-currency-region",
    'NoDateFieldNames': "Solution: " + DOCS_URL + "#toc-no-date-filed-names",
    'NoFirstDay': "Solution: " + DOCS_URL + "#toc-no-first-day",
    'NoGMTInfo': "Solution: " + DOCS_URL + "#toc-no-gmt-info",
    'NoLocale': "Solution: " + DOCS_URL + "#toc-no-locale",
    'NoValidCurrency': "Solution: " + DOCS_URL + "#toc-no-valid-currency",
    'NoWeekData': "Solution: " + DOCS_URL + "#toc-no-week-data"
};



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-intl/dist/es/error-solutions.js
// module id = ../../../../@progress/kendo-angular-intl/dist/es/error-solutions.js
// module chunks = vendor